import { createApp } from 'vue'
import App from './App.vue'
import "the-new-css-reset/css/reset.css"
import "@fortawesome/fontawesome-free/css/all.min.css"

createApp(App).mount('#app')
